import { Question } from "survey-core";
import { SurveyQuestionElementBase } from "survey-react-ui";

import { DownloadInfoWidget } from "./DownloadInfoWidget";
import { registerWidget } from "./registerWidget";

const QUESTION_TYPE = "downloadInfo";

export class DownloadInfoModel extends Question {
  getType() {
    return QUESTION_TYPE;
  }

  get hasTitle() {
    return false;
  }

  get buttonText() {
    return this.getPropertyValue("buttonText") || "Download Document";
  }

  set buttonText(val) {
    this.setPropertyValue("buttonText", val);
  }

  get buttonStyles() {
    return this.getPropertyValue("buttonStyles");
  }

  set buttonStyles(val) {
    this.setPropertyValue("buttonStyles", val);
  }
}
class DownloadInfoQuestion extends SurveyQuestionElementBase {
  renderElement() {
    const buttonText = this.question.buttonText;
    const buttonStyles = this.question.buttonStyles;
    const survey = this.question.survey as any;
    const isReadOnly = !!survey?.getVariable?.("_isReadOnly");

    const getSurveyVariable = (name: string) => survey?.getVariable?.(name);
    return (
      <DownloadInfoWidget
        buttonText={buttonText}
        buttonStyles={buttonStyles}
        isReadOnly={isReadOnly}
        getSurveyVariable={getSurveyVariable}
      />
    );
  }

  get question() {
    return this.questionBase as DownloadInfoModel;
  }
}

export function registerDownloadInfoWidget() {
  registerWidget({
    baseQuestion: "question",
    newQuestionName: QUESTION_TYPE,
    renderer: DownloadInfoQuestion,
    newModelFn: (name: string) => new DownloadInfoModel(name),
    newToolboxItem: {
      name: QUESTION_TYPE,
      iconName: "Download",
      title: "Download Info Button",
      json: {
        type: QUESTION_TYPE,
        buttonText: "",
        buttonStyles: {}
      }
    },
    extraProperties: ["buttonText", "buttonStyles"]
  });
}
